'use es6';

import Contact from 'customer-data-objects/contact/ContactRecord';
import PropTypes from 'prop-types';
const ContactType = PropTypes.instanceOf(Contact);
export default ContactType;